<script>

    import layer from "@/mixins/mapboxLayer";


    export default{

        mixins:[layer],
        
        name:"lake",

        data(){
            return {
                // zoomRange:[0,14],
                loadDelay:0,
            }
        },

        computed:{
            geoJSON:function(){
                return this.$store.getters.courses;
            },
        },

        watch:{
       
        },

        methods:{

        },

        
        source:function(){
            var lagoNormalRes = '/images/lago.png';
            var lagoHeightRes = '/images/lago@4x.png';

            var TL = _.util.inverseMercator(0, 0)
            var TR = _.util.inverseMercator(0, 2057.6)
            var BL = _.util.inverseMercator(1865.6, 2057.6)
            var BR = _.util.inverseMercator(1865.6, 0)
            var coordinate = [ TL, TR, BL, BR];

            return {
                    id:"lakelowres",
                    type: "image",
                    url: lagoNormalRes,
                    coordinates: coordinate
                }
        },

        style: function () {
            return {
                type: 'raster',
                paint: {
                    'raster-fade-duration':0,
                    'raster-hue-rotate':30,
                    'raster-opacity': {
                        "base": 1,
                        "stops": [
                            [9, 0.2],
                            [11, 1]
                        ]
                    },
                },
            }
        }

    }


</script>